import inputData from './inputData/testimonial-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'testimonial-form',
  title: 'Testimonial Form',
  description: 'Collect impactful, authentic testimonials from your customers to showcase real results and build trust.',
  image: '/images/templates/testimonial-form.png',
  tags: ['get-feedback', 'customer-success', 'product'],
  inputData: inputData,
  popular: true,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

